<si-login-page data-cy="login-page"
               [heading]="'APP.NAME' | translate"
               [subtitle]="'APP.CLAIM' | translate"
               [subheading]="'EWS'"
               [availableLanguages]="languages"
               [warningInitialText]="''">
</si-login-page>
